import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { CSSProperties } from 'react';
import Icon from 'features/shared/components/icons/Icon';
import styles from './infoitem.module.scss';

interface Props {
  title: string;
  value?: string | JSX.Element;
  valueBold?: boolean;
  icon?: IconProp;
  renderIcon?: () => React.ReactNode;
  iconColorClass?: string;
  className?: string;
}

const InfoItem = ({ title, value = "", valueBold = true, icon, renderIcon, iconColorClass, className }: Props) => {
  // helpers
  const getColorClass = (iconColorClass?: string) => {
    if (iconColorClass) {
      return iconColorClass;
    }
    else {
      return styles.defaulIcon;
    }
  }

  // render
  return (
    <div className={`d-flex align-items-center${className ? " " + className : ""}`}>
      {(icon !== undefined || renderIcon !== undefined) && (
        <span
        className={`mr-3 ${getColorClass(iconColorClass)}`}
        >
          {renderIcon !== undefined ? renderIcon() : <Icon icon={icon!} size="2x" fixedWidth />}
        </span>
      )}
      <div className={`d-flex flex-column ${styles.valueCol}`}>
        <div className="text-muted">{title}</div>
        <div className={`mt-n1 ${valueBold ? "font-weight-bold" : ""}`}>{value}</div>
      </div>
    </div>
  )
}

export default InfoItem;
